// show a "this product has been deleted" banner if the product has been deleted

import { TrashIcon } from '@heroicons/react/20/solid';
import Banner from '@ui/Banner';

export const DeletedBanner = () => {
  return (
    <Banner color="brand" rounded>
      <div className="flex items-center justify-center gap-[0.8rem]">
        <TrashIcon width={44} height={44} />
        This product has been deleted.
      </div>
    </Banner>
  );
};
